import { ICD_CODE_LIBRARY, ICD10LibraryData, icdCodeGroups, SETTINGS } from '@hb/shared'
import type { ICD10Group } from '@hb/shared'
import { useMemo } from 'react'
import { useDocument } from '../../../backend/db/hooks'

export const useICD10Groups = (): ICD10Group[] => {
  const { data } = useDocument<ICD10LibraryData>(SETTINGS, ICD_CODE_LIBRARY)
  return useMemo(() => {
    if (!data?.groups) return icdCodeGroups
    return Object.entries(data.groups)
      .sort(([, a], [, b]) => a.rank - b.rank)
      .map(([, g]) => ({
        name: g.name,
        codes: Object.entries(g.codes)
          .sort(([, a], [, b]) => a.rank - b.rank)
          .map(([, c]) => ({ code: c.code, description: c.description, keywords: c.keywords })),
      }))
  }, [data])
}
